export { default as StudentRegistration } from './student';
export { default as TeacherRegistration } from './teacher';